import { useQuery } from '@tanstack/react-query'
import { procedureTemplatesApi } from '@/api/procedureTemplatesApi'
import { useMockApi } from '@/lib/useMock'
import { useTenant } from '@/providers/TenantProvider'
import type { ProcedureType } from '@/types/cgt'

/**
 * The forms a hand-made task may run (z8nrz7fjzc): active templates of the kind
 * its unit calls for — Cleaning for a room, Equipment otherwise — the same rule
 * the server holds a cycle link to.
 */
export function useTaskFormTemplates(type: ProcedureType | null) {
  const { selectedTenantId } = useTenant()
  return useQuery({
    queryKey: ['procedure-templates', selectedTenantId, 'offerable', type],
    enabled: selectedTenantId !== null && type !== null && !useMockApi,
    queryFn: async () => (await procedureTemplatesApi.list({ offerable: true })).filter((t) => t.type === type),
  })
}
